const config = {
    // API keys removed - now handled by backend for security
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000',
    arEnabled: true,
    defaultMolecule: '/sample-molecules/caffeine.mol'
  };

  export default config;